<template>
  <div class="animated fadeIn">
    <b-row v-if="selectable" class="mb-2">
      <b-col>
        <b-button @click="setAllActive" block variant="light"
          >Select All</b-button
        >
      </b-col>
      <b-col>
        <b-button @click="emptyActive" block variant="light"
          >De-select All</b-button
        >
      </b-col>
    </b-row>
    <draggable
      v-model="sorted"
      :group="groupBy"
      @start="drag = true"
      @end="drag = false"
      class="list-group"
      ghost-class="ghost"
      :move="checkMove"
      handle=".handle"
    >
      <div
        v-for="(item, index) in sorted"
        :class="[
          'list-group-item',
          'selectable-list-item',
          isActive(item) !== false ? 'active' : null,
        ]"
        :key="getKeyVal(item)"
      >
        <b-row class="no-gutters">
          <b-col
            v-if="selectable && !hasSlot('addOnPrepend')"
            cols="1"
            class="
              list-group-item-inner
              handle
              bg-light
              text-center
              move-cursor
            "
            ><i class="fal fa-arrows" />
          </b-col>
          <b-col
            v-if="hasSlot('addOnPrepend')"
            cols="1"
            class="list-group-item-inner bg-light text-center hand-cursor"
            ><slot name="addOnPrepend" :item="item" />
          </b-col>
          <b-col v-if="hasSlot('beforeLabel')" class="list-group-item-inner">
            <slot name="beforeLabel" :item="item" />
          </b-col>
          <b-col
            :class="[
              'list-group-item-inner',
              'list-group-item-label',
              !selectable ? 'handle' : null,
            ]"
          >
            <slot
              v-if="hasSlot('label')"
              name="label"
              :item="item"
              :index="index"
            />
            <span v-if="!hasSlot('label')">{{ getLabelVal(item) }}</span>
          </b-col>
          <b-col v-if="hasSlot('afterLabel')" class="list-group-item-inner">
            <slot name="afterLabel" :item="item" />
          </b-col>
          <b-col
            v-if="selectable && !hasSlot('addOnAppend')"
            cols="2"
            class="list-group-item-inner bg-light text-center hand-cursor"
            @click="onSelect(item)"
            >Select</b-col
          >
          <b-col
            v-if="hasSlot('addOnAppend')"
            cols="1"
            class="list-group-item-inner bg-light text-center hand-cursor"
            ><slot name="addOnAppend" :item="item"></slot
          ></b-col>
        </b-row>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "SortableList",
  components: { draggable },
  props: [
    "list",
    "keyField",
    "labelField",
    "groupBy",
    "selectable",
    "selected",
  ],
  data() {
    return {
      initialized: false,
      sorted: [],
      active: [],
    };
  },
  methods: {
    getKeyVal(item) {
      return this.keyField.split(".").reduce((o, i) => o[i], item);
    },
    getLabelVal(item) {
      return this.labelField.split(".").reduce((o, i) => o[i], item);
    },
    checkMove() {
      this.initialized = true;
    },
    isActive(item) {
      const selected = this.getKeyVal(item);
      let index = false;

      this.active.forEach((key, i) => {
        if (selected === key) {
          index = i;
        }
      });

      return index;
    },
    onSelect(item) {
      const selected = this.getKeyVal(item);
      const index = this.isActive(item);

      if (index === false) {
        this.active.push(selected);
      } else {
        this.active.splice(index, 1);
      }

      this.$emit("onSelect", this.active);
    },
    setAllActive() {
      this.emptyActive();

      this.sorted.forEach((item) => {
        this.active.push(this.getKeyVal(item));
      });

      this.$emit("onSelect", this.active);
    },
    emptyActive() {
      this.active = [];

      this.$emit("onSelect", this.active);
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
    onSorted() {
      this.$emit("onOrderChange", JSON.parse(JSON.stringify(this.sorted)));
    },
    forceSort() {
      this.onSorted();
    },
  },
  watch: {
    sorted() {
      if (this.initialized) {
        this.onSorted();
      }
    },
  },
  mounted() {
    this.sorted = this.list;
    this.active = this.selected ? this.selected : [];

    if (this.selectable) {
      this.$emit("onSelect", this.active);
    }
  },
};
</script>
<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.selectable-list-item {
  padding: 0;
}
.selectable-list-item .list-group-item-inner {
  padding: 0.75rem 1.25rem;
}
.list-group-item.active {
  color: inherit;
  border-color: transparent;
}
.list-group-item.active .list-group-item-label {
  color: #fff;
}
.selectable-list-item {
  padding: 0;
}
.move-cursor {
  cursor: pointer;
  cursor: move;
}
.hand-cursor {
  cursor: pointer;
  cursor: hand;
}
</style>
